import PropTypes from 'prop-types'

export const propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.string
}

export const defaultProps = {}
